import { useAsyncEffect } from '@xylabs/sdk-react'
import { Quadkey, XyoWorldGeotokenSettingsClient } from '@xyo-network/sdk-xyoworld-js'
import { PropsWithChildren, useContext, useState } from 'react'

import { AuthenticationContext } from '../../Authentication'
import GeotokenContext from '../Context'
import Context from './Context'

interface Props {
  quadkey?: Quadkey
}

const Provider: React.FC<PropsWithChildren<Props>> = (props) => {
  const { geotoken } = useContext(GeotokenContext)
  const { auth } = useContext(AuthenticationContext)
  const quadkey = props.quadkey ?? geotoken?.quadkey
  const [settings, setSettings] = useState<XyoWorldGeotokenSettingsClient>()

  useAsyncEffect(
    // eslint-disable-next-line react-hooks/exhaustive-deps
    async (mounted) => {
      if (quadkey) {
        const settings = XyoWorldGeotokenSettingsClient.get(quadkey, auth?.token)
        await settings.load()
        if (mounted()) {
          setSettings(settings)
        }
        await settings.load(false)
      }
    },
    [quadkey, auth],
  )

  return <Context.Provider value={{ settings }}>{props.children}</Context.Provider>
}

export default Provider
